var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"test-audio-control"},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.$t(_vm.label)))]):_vm._e(),_c('button',{staticClass:"w3-input",on:{"click":function($event){_vm.$emit('input', new Date().valueOf())}}},[_c('icon',{attrs:{"name":"volume-up"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }